import { render, staticRenderFns } from "./GwShortLogo.vue?vue&type=template&id=742429fe"
import script from "./GwShortLogo.vue?vue&type=script&lang=js"
export * from "./GwShortLogo.vue?vue&type=script&lang=js"
import style0 from "./GwShortLogo.vue?vue&type=style&index=0&id=742429fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports